import { SecondaryFilter } from "@/modules/Dashboards/AdminDashboard/models/SecondaryFilter";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EVENT_EMITTER } from "../../constants/GenericSearchConstants";
import { ObjFilterList } from "../../model/List";

@Component({
  name: "FilterTypeUnique"
})
export default class FilterTypeUnique extends Vue {
  @Prop() itemFilter!: SecondaryFilter;
  @Prop({ default: () => false }) isPrincipal!: boolean;
  @Prop() private selectFilter!: ObjFilterList[];

  textFieldClass = STYLE_CLASSES.TEXT_FIELD;

  searchInput = "";

  mounted() {
    this.initFilter();
  }

  get placeholder() {
    return this.itemFilter.placeholder || this.itemFilter.name;
  }

  get optionsSelect(): ObjFilterList[] {
    return this.searchInput
      ? [{ key: this.searchInput, name: this.searchInput }]
      : [];
  }

  get selectFilterLocal() {
    return this.selectFilter;
  }

  set selectFilterLocal(filterSelected: ObjFilterList[]) {
    this.$emit(EVENT_EMITTER.UPDATE_SELECT_FILTER, filterSelected);
  }
  @Watch("searchInput")
  changeSelect() {
    this.selectFilterLocal = this.optionsSelect;
  }

  @Watch("selectFilter")
  initFilter() {
    this.searchInput =
      this.selectFilterLocal && this.selectFilterLocal.length == 1
        ? this.selectFilterLocal[0].key
        : "";
  }

  change() {
    if (this.isPrincipal) {
      this.$emit(EVENT_EMITTER.CHANGE);
    }
  }
}
